import { createFileRoute, redirect } from '@tanstack/react-router'
import { ApiError } from '../lib/api'
import { meQuery } from '../lib/queries'

// The front door only routes: signed out goes to the welcome page, signed in
// goes to your league, or to "start" if you don't have one yet.
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    let me
    try {
      me = await context.queryClient.ensureQueryData(meQuery)
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) throw redirect({ to: '/welcome' })
      throw e
    }
    const first = me.leagues?.[0]
    if (first) throw redirect({ to: '/l/$slug', params: { slug: first.slug } })
    throw redirect({ to: '/start' })
  },
})
